var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper ml-n8"},[(_vm.isIcon)?_c('v-icon',{class:_vm.colorClass,style:(_vm.topStyle)},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('div',{staticClass:"pl-8"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }